import React from 'react';
import styled from 'styled-components';
import { Text } from '@openfin/ui-library';
import { FormikErrors, FormikValues, FormikTouched, useFormikContext } from 'formik';

import { SingleLineText } from '../FormHelpers';

export const ERROR_LABEL_HEIGHT = 20;

interface ErrorLabelProps {
  name: string;
}

export const ErrorLabel: React.FC<ErrorLabelProps> = (props) => {
  const { name } = props;
  const { errors, touched } = useFormikContext();
  const error = (errors as FormikErrors<FormikValues>)[name];
  const hasError = !!error;
  const hasTouched = (touched as FormikTouched<FormikValues>)[name];
  const maxHeight = hasError && hasTouched ? ERROR_LABEL_HEIGHT : 0;

  return <Label style={{ maxHeight }}>{error}</Label>;
};

const Label = styled(Text).attrs({ className: 'invalid', size: 'base' })`
  height: ${ERROR_LABEL_HEIGHT}px;
  max-height: 0;
  max-width: 280px;
  color: ${({ theme }) => theme.palette.statusCritical};
  margin-top: ${({ theme }) => theme.px.base};
  ${SingleLineText}
  transition: max-height 300ms ease-out;
`;
